module.exports = __webpack_public_path__ + "img/create-migration.99ffd001.svg";